import { Fragment, useEffect } from "react";
import { signal, useSignal } from "@preact/signals-react";

import Button from "componentsv2/button/Button";
import CharInline from "componentsv2/form/CharInline";
import NumericInline from "componentsv2/form/NumericInline";
import Text from "componentsv2/form/Text";
import SelectionCard from "componentsv2/form/SelectionCard";
import { Alert } from "componentsv2/widgets/Alert";
import {
  notesField,
  statementField,
  amountField,
  voucherField,
} from "./PaymentFields";
import proxy from "api/proxy";
import func from "tools/functions";

const showAlert = signal({
  status: false,
  text: "",
  color: "",
  icon: "",
});

function WizardAddPayment({
  onClose,
  reload,
  signalReset,
  parentRec,
  record: recordForm,
}) {
  const selectedCard = useSignal(null);
  const payMethods = useSignal([]);
  const amount = useSignal(0);
  const residual = useSignal(0);
  const voucher = useSignal("");
  const notes = useSignal("");
  const loading = useSignal(false);
  const _terminal = func.getCookie();
  // console.log("parentRec  > > > > ", parentRec);

  function resetWizard() {
    selectedCard.value = null;
    residual.value = parentRec.pending_to_pay;
    amount.value = residual.value;
    showAlert.value = { status: false, text: "", color: "", icon: "" };
    voucher.value = "";
  }

  useEffect(() => {
    getMethodPayments();
    resetWizard();
  }, [signalReset]);

  useEffect(() => {
    residual.value = parentRec.pending_to_pay;
    amount.value = parentRec.pending_to_pay;
  }, [parentRec?.pending_to_pay]);

  async function addPayment() {
    loading.value = true;
    if (!parentRec.party) {
      onClose(false, "missing_party");
      loading.value = false;
      return;
    }

    console.log("selectedCard ...", selectedCard.value);
    const toStore = {
      booking: parentRec.id,
      party: parentRec.party.id,
      statement: selectedCard.value.id,
      amount_to_pay: Math.round(amount.value),
      number: voucher.value,
      notes: notes.value,
    };
    const values = {
      model: "hotel.booking",
      method: "add_payment",
      args: [toStore],
    };

    const { error } = await proxy.methodCall(values);
    const newResidual = Math.round(residual.value - amount.value);
    if (newResidual > 0) {
      residual.value = newResidual;
      amount.value = newResidual;
      showAlert.value = {
        status: true,
        text: "hotel.booking.wizard_payment_correct",
        color: "bg-green-300",
        icon: "check",
      };
    } else {
      onClose(true, error);
    }
    loading.value = false;
    await reload();
  }

  function onChange(field, value) {
    console.log("onChange", field, value);
    field.value = value;
  }

  async function getMethodPayments() {
    const { data } = await proxy.search(
      "account.statement",
      [
        ["sale_device", "=", Number(_terminal.device_id)],
        ["state", "=", "draft"],
      ],
      ["id", "rec_name", "journal.name", "journal.require_voucher", "name"],
    );
    if (data.length > 0) {
      const updatedData = data.map((item) => ({
        ...item,
        rec_name: item["journal."]?.name,
      }));

      payMethods.value = updatedData;
    }
  }

  return (
    <Fragment>
      <Alert
        show={showAlert.value?.status}
        onClose={() => (showAlert.value = false)}
        text={showAlert.value?.text}
        color={showAlert.value?.color}
        icon={showAlert.value?.icon}
        autoRemove={true}
      />
      <SelectionCard
        {...statementField}
        options={payMethods.value}
        data={selectedCard}
      />
      {selectedCard.value && (
        <div className="mt-2">
          <div>
            <div className="border-b mt-4 h-1 border-gray-300" />
            {selectedCard.value["journal."]?.["require_voucher"] && (
              <CharInline
                {...voucherField}
                data={voucher}
                onChange={onChange}
              />
            )}
            <NumericInline
              {...amountField}
              data={amount}
              autoFocus={true}
              onChange={onChange}
            />
          </div>
          <Text {...notesField} data={notes} />
          <div className="flex justify-end mt-10 space-x-4 ">
            <Button
              color="rose"
              onClick={() => onClose(false)}
              content="button.cancel"
              loading={loading.value}
              size="w-[270px]"
            />
            <Button
              onClick={addPayment}
              content="hotel.booking.wiz_payment.button_pay"
              loading={loading.value}
              size="w-[270px]"
            />
          </div>
        </div>
      )}
    </Fragment>
  );
}

export default WizardAddPayment;
